import { CostCenter } from './../entities/costCenter';
import { Injectable, Injector } from '@angular/core';
import { PayStub } from '../entities/pay-stub';
import { Subject, Observable } from 'rxjs/Rx';
import { tap, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BaseService } from '../../shared/_utils/services/base-service';
import * as FileSaver from 'file-saver';
import { catchError } from 'rxjs/operators';
import { ParamsContractGenerate } from '../model/params-contract-generate';

@Injectable()
export class ContractGenerateService extends BaseService {

  private url = '/api/contractGenerate/';

  constructor(injector: Injector, private http: HttpClient) { super(injector); }

  searchContractGenerate(paramsContractGenerate: ParamsContractGenerate
  ): Observable<any> {
    this.spinnerService.showAll();
    const url = `${this.rutaServidor}${this.url}search`;
    return this.httpClient.post<any>(url, paramsContractGenerate,)
      .pipe(
        tap(response => {
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  contractGenerate(paramsContractGenerate: ParamsContractGenerate
  ): Observable<any> {
    this.spinnerService.showAll();
    const url = `${this.rutaServidor}${this.url}downloadFormat`;
    return this.httpClient.post<any>(url, paramsContractGenerate,)
      .pipe(
        tap(response => {
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  downloadPDF(url:string ,object: any , nameFile : string): Observable<Blob> {
    let ruta = this.rutaServidor + this.url  +  url; 
    this.spinnerService.showAll();
    return this.httpClient.post(ruta, object, {responseType: 'blob' })
        .pipe( 
            map(res =>  { 
                this.spinnerService.hideAll();
                let bean = new Blob([res],{ type: 'application/pdf'});
                FileSaver.saveAs(bean, nameFile);
                return bean;
             }   ),
            catchError((err) => { 
                //console.log("catchError : "  + catchError);
               this.spinnerService.hideAll();
               this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
               return new Observable<Blob>();
            })
             
            ) ;

}
}



// WEBPACK FOOTER //
// ./src/app/core/services/contract-generate.service.ts